import axios from 'axios'
import {Message} from 'element-ui'
import {getToken} from '@/utils/auth'
import store from '@/store'
import {globalParams} from '@/utils'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000,
  headers: {
    "Content-Type": "multipart/form-data",
  }
})

service.interceptors.request.use(
  config => {
    if (config.data == undefined) {
      config.data = globalParams({});
    } else {
      config.data = globalParams(config.data);
    }
    if (store.getters.token) {
      config.headers["authorization"] = getToken();
    }

    return config;
  },
  error => Promise.reject(error)
)

service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code === 200) {
      return res
    } else if (res.code === 401) {
      store.dispatch('user/logout')
      Message.error(res.msg);
      return Promise.reject(res)
    } else {
      Message.error(res.msg);
      return Promise.reject(res)
    }
  },
  (err) => {
    Message({
      message: err && (err.msg || err.message) || '网络错误',
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(err);
  }
)

export default service


